import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

type TEnrichmentsSelection = {
  stt: boolean;
  logos: boolean;
  peoples: boolean;
  ocr: boolean;
  advertising: boolean;
};
type TRelaunchSegment = {
  id: string;
  enrichments: TEnrichmentsSelection;
};
export async function relauchSegment({ id, enrichments }: TRelaunchSegment): Promise<unknown> {
  return mediaManagerClient.patch(`/api/v1/segments/${id}/relaunch`, enrichments);
}

type MutationFn = typeof relauchSegment;

type TUsePatchRelaunchSegment = {
  config?: MutationConfig<MutationFn>;
};

export function usePatchRelaunchSegment({ config = {} }: TUsePatchRelaunchSegment = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: relauchSegment,
    onError(error) {
      addErrorNotification(
        t('Ha habido un fallo lanzando los enriquecimientos'),
        t('Ha habido un error durante el proceso, vuelva a intentarlo más tarde')
      );
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(
        t('Se han lanzado los enriquecimientos'),
        t('El proceso ha sido un éxito')
      );
    },
  });
}
